<template>
  <div class="fadeIn">
    <div class="ra-auth--form__header">
      <h1>Welcome</h1>
      <p>Provide required information to continue.</p>
    </div>
    <div class="ra-auth--form__form">
      <el-form :model="form" label-position="top" ref="form" @submit.prevent>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="Email"
              prop="identifier"
              :rules="validateEmail('Email')"
            >
              <el-input
                type="email"
                v-model="form.identifier"
                @keydown.enter.native="login"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="Password"
              prop="password"
              :rules="validateField('Password')"
            >
              <el-input
                type="password"
                v-model="form.password"
                show-password
                @keydown.enter.native="login"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <div class="form-extras">
              <el-checkbox v-model="form.rememberMe">Remember me</el-checkbox>
              <router-link :to="{ name: 'forgot-password' }"
                >Forgot password?</router-link
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="ra-auth--form__actions">
      <el-button :loading="loading" type="primary" @click="login"
        >Login</el-button
      >
    </div>
  </div>
</template>

<script>
import { currentUser, getActiveOrganisationWallet } from "@/lib/utils";
import * as actions from "@/store/action-types";
import inviteMixin from "@/mixins/invite";

export default {
  name: "Login",
  mixins: [inviteMixin],
  data() {
    return {
      currentUser: currentUser(),
      loading: false,
      form: {
        identifier: "",
        password: "",
        rememberMe: false
      }
    };
  },

  methods: {
    login() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http
          .post("auth/local/users/authenticate", {
            body: this.form,
            method: "POST"
          })
          .then(response => {
            const resData = response.data;
            if (resData.status === "error") {
              this.loading = false;
              this.gaTrack("Failed", this.form.identifier);
              this.handleErrors(resData);
            } else {
              this.gaTrack("Successful", this.form.identifier);
              this.$store.dispatch(actions.LOGIN, resData);

              // Route to dashboard
              this.$router.push({
                name: "home.index",
                params: { disableSwitch: "true" }
              });

              if (
                resData.organisation_account_user &&
                resData.organisation_account_user.status_id === 10
              ) {
                this.inviteAction(
                  resData.organisation_account_user.organisation_id,
                  "accept"
                );
              }

              if (resData.organisation) {
                this.getWallet();
              }
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    },

    getWallet() {
      if (!this.userCan("payment", "wallet.getall")) {
        return;
      }
      getActiveOrganisationWallet(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification(
            "Error",
            "Unable to get wallet information.",
            "danger"
          );
        });
    },

    gaTrack(type, identifier) {
      this.$ga.event({
        eventCategory: "Login",
        eventAction: type,
        eventLabel: identifier
      });
    }
  },

  created() {
    sessionStorage.clear();
    this.$ga.page({
      page: "/login",
      title: "Login",
      location: window.location.href
    });
  }
};
</script>

<style scoped lang="scss">
.form-extras {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  a {
    font-size: 0.875rem;
  }
}

.ra-icon--eye-off::before,
.ra-icon--eye::before {
  cursor: pointer;
}
</style>
